import { IMessagingService } from "../services";

class LoadingIndicator
{
    private loadingOverlayEl: HTMLElement;

    constructor(containerEl: HTMLElement, messagingService: IMessagingService) {

        this.loadingOverlayEl = containerEl;
        this.loadingOverlayEl.classList.remove("loading__overlay--loading");

        messagingService.OnLoading().subscribe(loading => {

            if (loading) {
                this.loadingOverlayEl.classList.add("loading__overlay--loading");
                this.loadingOverlayEl.setAttribute("aria-busy", "true");
            }
            else {
                this.loadingOverlayEl.classList.remove("loading__overlay--loading");
                this.loadingOverlayEl.setAttribute("aria-busy", "false");
            }
        });

        this.loadingOverlayEl.classList.remove("loading__overlay--loading");
    }
};

export { LoadingIndicator }